import {isValidLogin} from "./authService";

function getheaders() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let cosToken = localStorage.getItem('cosToken')
    if (!isValidLogin('ADMIN')) {
        window.location.href = "/login";
    }
    myHeaders.append("Authorization", cosToken)
    return myHeaders;
}

export async function login(username, password, token) {

    let loginheaders = new Headers();
    loginheaders.append("Content-Type", "application/json");
    loginheaders.append('X-Recaptcha-Token', token)

    let requestOptions = {
        method: 'POST', headers: loginheaders,
        body: JSON.stringify({
            username: username,
            password: password
        })
    };

    return fetch("/api/login", requestOptions)
}

export async function getAllUsers() {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };

    return fetch("/api/user/all", requestOptions)
}

export async function getUserbyUsername(username) {

    let myHeaders = getheaders();

    let requestOptions = {
        method: 'GET', headers: myHeaders, redirect: 'follow'
    };

    return fetch("/api/user/" + username, requestOptions)
}

export async function changeUserDetail(username, userdetails) {

    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(userdetails)
    };

    return fetch("/api/user/" + username, requestOptions)
}

export async function addNewUser(userdetails) {

    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(userdetails)
    };

    return fetch("/api/user", requestOptions)
}
